import PcHeader from '@/views/layout/pc/Header';
import PcFooter from '@/views/layout/pc/Footer';
import PcSideBar from '@/views/layout/pc/SideBar.vue';

import { Role } from '@/helpers/role';

import ListUserManagement from '@/views/components/admin/UserManagement/List';
import ListGroupManagement from '@/views/components/admin/GroupManagement/List';
import ListCompanyManagement from '@/views/components/admin/CompanyManagement/List';
import ListDMOSManagement from '@/views/components/admin/DMOSManagement/List';
import ListDOCManagement from '@/views/components/admin/DOCManagement/List';
import ListOCRManagement from '@/views/components/admin/OCRManagement/List';
import ListInfoManagement from '@/views/components/admin/InfoManagement/List';

const routerAdmin = [
    {
        path: '/admin/users',
        name: 'ListUserManagement',
        components: {
            pcheader: PcHeader,
            pcbody: ListUserManagement,
            sidebar: PcSideBar,
            pcfooter: PcFooter,
        },
        meta: {
            public: false,
            authorize: [Role.SysAdmin.id, Role.Admin.id, Role.PwReset.id, Role.ReadOnly.id],
        },
    },
    {
        path: '/admin/groups',
        name: 'ListGroupManagement',
        components: {
            pcheader: PcHeader,
            pcbody: ListGroupManagement,
            sidebar: PcSideBar,
            pcfooter: PcFooter,
        },
        meta: {
            public: false,
            authorize: [Role.SysAdmin.id],
        },
    },
    {
        path: '/admin/companies',
        name: 'ListCompanyManagement',
        components: {
            pcheader: PcHeader,
            pcbody: ListCompanyManagement,
            sidebar: PcSideBar,
            pcfooter: PcFooter,
        },
        meta: {
            public: false,
            authorize: [Role.SysAdmin.id],
        },
    },
    {
        path: '/admin/dmos',
        name: 'ListDMOSManagement',
        components: {
            pcheader: PcHeader,
            pcbody: ListDMOSManagement,
            sidebar: PcSideBar,
            pcfooter: PcFooter,
        },
        meta: {
            public: false,
            authorize: [Role.SysAdmin.id],
        },
    },
    {
        path: '/admin/doc',
        name: 'ListDOCManagement',
        components: {
            pcheader: PcHeader,
            pcbody: ListDOCManagement,
            sidebar: PcSideBar,
            pcfooter: PcFooter,
        },
        meta: {
            public: false,
            authorize: [Role.SysAdmin.id],
        },
    },
    {
        path: '/admin/ocr',
        name: 'ListOCRManagement',
        components: {
            pcheader: PcHeader,
            pcbody: ListOCRManagement,
            sidebar: PcSideBar,
            pcfooter: PcFooter,
        },
        meta: {
            public: false,
            authorize: [Role.SysAdmin.id],
        },
    },
    {
        path: '/admin/info',
        name: 'ListInfoManagement',
        components: {
            pcheader: PcHeader,
            pcbody: ListInfoManagement,
            sidebar: PcSideBar,
            pcfooter: PcFooter,
        },
        meta: {
            public: false,
            authorize: [Role.SysAdmin.id],
        },
    },
];

export default routerAdmin;



// WEBPACK FOOTER //
// ./src/router/admin.js